<template>
  <date-picker
    class="date-picker"
    :value="value"
    :popover="{ placement, visibility }"
    @input="$emit('change', $event)"
  >
    <ag-input class="input" :id="id" :value="displayValue" :readonly="true" />
  </date-picker>
</template>

<script>
  import moment from "moment";
  import DatePicker from "v-calendar/lib/components/date-picker.umd";

  export default {
    name: "Date",
    props: {
      id: String,
      value: Date,
      placement: {
        type: String,
        default: "bottom",
        validator: value =>
          ["auto", "top", "right", "bottom", "left"].indexOf(value) >= 0
      },
      visibility: {
        type: String,
        default: "click",
        validator: value =>
          [
            "hover-focus",
            "hover",
            "focus",
            "click",
            "visible",
            "hidden"
          ].indexOf(value) >= 0
      }
    },
    computed: {
      displayValue() {
        if (!this.value) {
          return "";
        }

        return moment(this.value).format("MM/DD/YYYY");
      }
    },
    components: {
      DatePicker
    }
  };
</script>

<style lang="scss">
  .date-picker {
    .input {
      width: 100%;
      box-sizing: border-box;
    }
  }
</style>
